export const environment = {
  production: false,
  apiBaseUrl: 'https://tos-staging.cnbtek.com/api', // Staging API URL // http://13.201.194.192:8080/api
  enableLocalStorageEncryption: true,
  encryptionKey: 'smart-tos-staging',
  showConsoleLogs: true,
};
